export abstract class CachingServiceImpl {
  public prefix = 'tvpil';

  constructor(config: CacheConfig) {
    this.prefix = config.prefix + '_';
  }

  abstract getItem(key: string): unknown | null | Promise<unknown | null>;

  abstract setItem(key: string, data: unknown, ttl: number | undefined): void | Promise<void>;

  abstract removeItem(key: string): void | Promise<void>;

  abstract clear(): void | Promise<void>;

  abstract removeAllBySubPrefix(subPrefix: string): void | Promise<void>;
}

export interface CacheConfig {
  prefix: string; // Default 'tvpil'
}
